export default __webpack_public_path__ + "static/media/envelope.97969ee9.svg";